<template>
  <div>
    <div class="container-fluid">
      <popUp v-if="toggle" v-on:doClose="close" :size="'large'">
        <div class="pop-title" slot="title">
        </div>
        <div slot="title">
          <h2 class="mb-3">能力雷達圖</h2>
          <div class="container">
            <div class="row align-items-center">
              <!-- <div class="col">
                <div class="pop-info-box">
                  <div class="title">
                    平均成績
                  </div>
                  <div class="content" >
                    {{Math.floor(speakScore.score)}}
                  </div>
                </div>
              </div> -->
              <div class="col" v-for="(item, index) in speakScore.abilities" :key="index">
                <div class="pop-info-box">
                  <div class="title">
                    {{changeKey(index)}}
                  </div>
                  <div class="content" >
                    {{Math.floor(item)}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div slot="info" class="info-main mt-3 d-flex  align-items-center  justify-content-between" v-if="datasets" >
          <div class="pop-box">
            <div class="main-title">
              <!-- 平均成績: -->
              學習平均:
            </div>
            <div class="main-content" >
              {{Math.floor(speakScore.score)}}
            </div>
          </div>
          <div class="pop-box ">
            <RadarChart class="m-auto" :datasets="datasets"  style="max-width:462px"/>
          </div>
        </div>
      </popUp>
      <div class="row banner align-items-center">
        <div class="col-md-4 col-12">
          <div class="personal_info">
            <div class="d-flex">
              <img class="circle_picture" src="../assets/image/pic/maxresdefault.jpg" />
              <div class="ml-3">
                <div class="d-flex">
                  <!-- <div class="cefr my-auto mr-2">{{personalData.level}}</div> -->
                  <h2>
                    {{personalData.name}}
                  </h2>
                </div>
                <p v-if="personalData.enterprise_name" class="mt-3">
                  學校: {{personalData.enterprise_name}}
                </p>
                <p class="mt-3">
                  班別: {{personalData.group_name}}
                </p>
                <p class="mt-0">
                  課程期間: {{segment}}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-8 col-12 banner-box">
          <div class="container">
            <div class="row align-items-center align-items-end px-5">
              <div class="col">
                <div class="info-box">
                  <div class="title d-flex justify-content-center align-items-center" style="background:#5d5d5d;color:#fff">
                    學習平均
                    <div class="mx-1 info pointer" @mouseover="infoActive = true" @mouseleave="infoActive = false">
                      i
                    </div>
                    <div class="info-content" :class="{hide:!infoActive}">
                      考場成績不列入學習平均計算
                    </div>
                  </div>
                  <div class="content" style="font-weight:800;font-size:1.5rem">
                    {{Math.floor(speakScore.score)}}
                  </div>
                </div>
              </div>
              <div class="col" v-for="(item, index) in speakScore.abilities" :key="index">
                <div class="info-box">
                  <div class="title">
                    {{changeKey(index)}}
                  </div>
                  <div class="content" >
                    {{Math.floor(item)}}
                  </div>
                </div>
              </div>
              <div  @click="toggle = true">
                <font-awesome-icon class="pointer"  @click="close" :icon="['fa', 'share-square']" style="color:#fff; position: absolute; bottom: 10px"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="d-flex menu">
            <div @click="goPage('LeaderBoard')"  class="title d-sm-flex pointer" :class="{'active' : $route.name === 'LeaderBoard'}">
              <img style="height:30px" src="../assets/image/pic/icon_company.png" alt="">
              <div class="my-auto">
                每月排行
              </div>
            </div>
            <div @click="goPage('Collections')"  class="title d-sm-flex pointer" :class="{'active' : $route.name === 'Collections'}">
              <img style="height:30px" src="../assets/image/pic/icon_tag.png" alt="">
              <div class="my-auto">
                我的收藏
              </div>
            </div>
            <div @click="goPage('Record')" class="title  d-sm-flex pointer" :class="{'active' : $route.name === 'Record' || $route.name === 'VoiceRecord' || $route.name === 'StudentInfo' || $route.name === 'PersonalVoiceRecord'}">
              <img style="height:30px" src="../assets/image/pic/icon_book.png" alt="">
              <div class="my-auto">
                學習紀錄
              </div>
            </div>
            <div @click="goPage('Exam-hall')" class="title  d-sm-flex pointer" :class="{'active' : $route.name === 'Exam-hall' || $route.name === 'Oral-exam'|| $route.name === 'Exam-detail' }">
              <img style="height:30px" src="../assets/image/pic/icon_text.png" alt="">
              <div class="my-auto">
                測驗考場
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
// import Video from '@/components/Video.vue'
import {mapActions, mapState} from 'vuex'
import popUp from '../components/PopUp.vue'
import RadarChart from '../components/RadarChart.vue'
import api from '../store/api'
export default {
  name: 'Personal',
  data () {
    return {
      infoActive: false,
      personalData: {},
      target: {},
      toggle: false,
      speakScore: {
        score: 0,
        abilities: [
          0,0,0,0
        ]
      },
      datasets: {}
    }
  },
  watch: {
    'auth.personalData' (data) {
      this.personalData = data
    }
  },
  computed: {
    ...mapState(['auth']),
    segment () {
      return this.moment(this.personalData.group_begin_at).format('YYYY-MM-DD') + ' ~ ' + this.moment(this.personalData.group_end_at).format('YYYY-MM-DD')
    }
  },
  mounted() {
    this.scrollTop()
    this.getPersonalData()
    this.getSpeakScore()
    this.getTarget ()
  },
  methods: {
    ...mapActions({
      getUser: 'getUser'
    }),
    goPage (el) {
      this.$router.push({ name: el})
    },
    async getTarget () {
      const { data } = await api.get('/me/records')
      this.target = data.data
      this.target.segment = this.segment
      this.target.standard = this.personalData.enterprise_standard
    },
    async getPersonalData () {
      if (this.auth.personalData) {
        this.personalData = this.auth.personalData
      } else {
        await this.getUser()
      }
    },
    async getSpeakScore () {
      const labels = []
      // labels = ['Speech rate Speech rate', '斷句 Pausing', 'Pronunciation accuracy Pronunciation accuracy', '音量 Volume', '節奏 Rhythm', '語調 Intonation']
      const { data } = await api.get('/me/speak')
      this.speakScore = data.data
      this.datasets = {
        labels: [ '學習平均','精確度', '流暢度', '完整性', '韻律'],
        datasets: [
          {
            label: '',
            backgroundColor: '#f87979a5',
            radius: 6,
            pointRadius: 6,
            pointBorderWidth: 3,
            data: [data.data.score,...data.data.abilities],
            borderColor: '#f87979',
          }
        ]
      }
    },
    testAccount () {
      alert('測試帳號不提供此功能')
    },
    scrollTop () {
      const currentScroll = document.documentElement.scrollTop || document.body.scrollTop
      if (currentScroll > 0) {
        window.scrollTo(0, 0)
      }
    },
    close (close) {
      this.toggle = close
      this.videoData = null
    },
    openInfo () {
      this.infoActive = !this.infoActive
    },
    changeKey(el) {
      switch (el) {
        case 0:
          return '精確度'
        case 1:
          return '流暢度'
        case 2:
          return '完整性'
        case 3:
          return '韻律'
      }
    }
  },
  components: {
    popUp,
    RadarChart
    // Video
  }
}
</script>
<style lang="scss" scoped>
  .banner {
    min-height: 250px;
    // height: 30vh;
    background-image: url('../assets/image/pic/bg_member_top.jpg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    .cefr {
      padding: 2px;
      font-size: 1rem;
      line-height: 1rem;
      background-color: rgb(255, 0, 0);
      border: 2px solid #fff;
      border-radius: 20%;
    }
    h2 {
      margin: 0;
    }
  }
  .main {
    background-color: #eee;
  }
  .circle_picture {
    width: 100px;
    height: 100px;
    border-radius:50%;
  }
  .personal_info {
    margin: 0 30%;
    width: 100%;
    text-align: left;
    color: #fff;
    position: absolute;
    top:50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .active {
    color: red;
  }
  .info-box {
    min-width: 100px;
    margin: 5px;
    .title {
      padding: 3px;
      max-width: 200px;
      margin: auto;
      text-align:center;
      background-color: #fff;
      font-weight: bold;
      color: #4a7afd;
    }
    .content {
      margin: auto;
      padding: 10px;
      max-width: 200px;
      color: #fff;
      border: 1px #fff solid;
    }
  }
  .pop-box {
    width: 50%;
    text-align: center;
    .main-title {
      font-size: 4rem;
      font-weight: 600;
    }
    .main-content {
      font-size: 6rem;
      font-weight: 600;
    }
  }
  .pop-info-box {
    margin: 10px;
    text-align: center;
    .title {
      padding: 3px;
      max-width: 200px;
      background-color: rgb(24, 97, 255);
      font-weight: bold;
      color: #fff;
    }
    .content {
      padding: 10px;
      max-width: 200px;
      color: #51A8DD;
      border: 1px #51A8DD solid;
    }
  }
  .info {
    border-radius: 50px;
    background-color: #000;
    margin: auto;
    width: 16px;
    height: 16px;
    color: #fff;
    font-size: .8rem;
  }
  .info-content {
    padding: 10px;
    left: 0px;
    top: 35px;
    position: absolute;
    width: 240px;
    height: 40px;
    color: #ffffff;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 500;
  }
  .hide {
    display: none;
  }
  .menu {
    .title {
      margin: 20px;
      font-weight: bolder;
    }
  }
  @media(max-width: 1080px){
    .banner-box {
      display: none;
    }
    .personal_info {
      img {
        display: none;
      }
    }
  }
</style>
